import { renderBelowFoldBands } from "@/components/showcase/below-fold";
import { smoothScrollBehavior } from "@/lib/scroll-behavior";

/** Main multi-tier plan cards; absent on single-plan / legacy pages. */
const COURSE_PRICING_COMPARISON_ID = "course-pricing-comparison";
/** Sidebar pricing card (all modes). */
const COURSE_PRICING_SIDEBAR_ID = "course-pricing-sidebar";

/**
 * Scrolls to the in-page plan comparison when present, otherwise the sidebar
 * pricing block.
 */
export function scrollToCoursePricingSection(): void {
  // `SITE-CRS02`: the bands above it skip layout until rendered; render them first.
  renderBelowFoldBands();
  const comparison = document.getElementById(COURSE_PRICING_COMPARISON_ID);
  const sidebar = document.getElementById(COURSE_PRICING_SIDEBAR_ID);
  (comparison ?? sidebar)?.scrollIntoView({
    behavior: smoothScrollBehavior(),
    block: "start",
  });
}

/** Multi-tier “full comparison” — targets the stream plan grid only. */
export function scrollToCoursePricingComparison(): void {
  renderBelowFoldBands();
  document.getElementById(COURSE_PRICING_COMPARISON_ID)?.scrollIntoView({
    behavior: smoothScrollBehavior(),
    block: "start",
  });
}
